globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { EmployerCard, EmployerCardHeader, EmployerCardImages, EmployerCardInfo, EmployerCardFooter } from './employer-card';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function EmployerRestaurantCard(_ref) {
  var address = _ref.address,
      pictures = _ref.pictures,
      restaurantName = _ref.restaurantName,
      restaurantLogo = _ref.restaurantLogo,
      types = _ref.types,
      candidates = _ref.candidates,
      openJpsCount = _ref.openJpsCount,
      href = _ref.href,
      onClick = _ref.onClick;

  var _useTranslation = useTranslation('common'),
      translateCommon = _useTranslation.t;

  var badgeVariant = openJpsCount ? 'success' : 'disabled';
  var bagdeText = openJpsCount ? translateCommon('open_positions', {
    count: openJpsCount
  }) : translateCommon('closed_positions');
  var restaurantTypes = useMemo(function () {
    return types === null || types === void 0 ? void 0 : types.map(function (type) {
      return type.type_var.label;
    }).join(', ');
  }, [types]);
  var images = useMemo(function () {
    return (pictures === null || pictures === void 0 ? void 0 : pictures.map(function (picture) {
      return picture.url;
    })) || [];
  }, [pictures]);
  return /*#__PURE__*/_jsxs(EmployerCard, {
    href: href,
    onClick: onClick,
    children: [/*#__PURE__*/_jsx(EmployerCardHeader, {
      badge: openJpsCount ? {
        text: bagdeText,
        variant: badgeVariant
      } : undefined,
      logo: restaurantLogo,
      title: restaurantName
    }), /*#__PURE__*/_jsx(EmployerCardImages, {
      images: images
    }), /*#__PURE__*/_jsx(EmployerCardInfo, {
      info: {
        address: address,
        businessName: restaurantTypes
      }
    }), !!(candidates !== null && candidates !== void 0 && candidates.candidates) && /*#__PURE__*/_jsx(EmployerCardFooter, {
      notification: {
        candidateCount: candidates === null || candidates === void 0 ? void 0 : candidates.count,
        message: candidates === null || candidates === void 0 ? void 0 : candidates.message,
        candidates: candidates === null || candidates === void 0 ? void 0 : candidates.candidates,
        isAllSpontaneous: candidates === null || candidates === void 0 ? void 0 : candidates.isAllSpontaneous
      }
    })]
  });
}
export default EmployerRestaurantCard;